import { useEffect } from "react";
import usePagination from "./usePagination";
import { useQuery } from "@apollo/client";
import { GET_SOS_ONLINE_STATUSES } from "graphql/queries/sos_statuses";
import { ISosOnlineStatus, ISosOnlineStatusIndexParams } from "models/Sos";

const useSosOnlineStatuses = ({ }: ISosOnlineStatusIndexParams) => {

    const hookSosOnlineStatuses = usePagination<ISosOnlineStatus>({});

    const { data, loading } = useQuery(GET_SOS_ONLINE_STATUSES(), {
        pollInterval: 1000*60, //Actualiza cada minuto
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only',
    });

    useEffect(() => {
        // console.log("🚀 ~ loading:", loading)
        if (loading) {
            hookSosOnlineStatuses.loadingStart();
        } else {
            hookSosOnlineStatuses.loadingEnd();
        }

        if (data) {
            // console.log("🚀 ~ useSosOnlineStatuses ~ data:", data)
            const { its_sos_online_status: dataSosStatuses, its_sos_online_status_aggregate } = data;
            const { count: totalItems } = its_sos_online_status_aggregate.aggregate;
            hookSosOnlineStatuses.setData(dataSosStatuses.map((item: ISosOnlineStatus) => ({ ...item, id: item.sos_id })));
            hookSosOnlineStatuses.setTotalItems(totalItems);
        }
    }, [data, loading]);

    return hookSosOnlineStatuses;
};

export default useSosOnlineStatuses;
